import React, { useState } from 'react';
import { ScreenHeader } from '../components/ScreenHeader';
import { MetaLabel } from '../components/MetaLabel';
import { CheckControl } from '../components/CheckControl';
import { Lightbox } from '../components/Lightbox';
import { useShoot } from '../contexts/ShootContext';
import type { ShotItem } from '../types/shoot';
export function Shots() {
  const {
    shotSections,
    isShotChecked,
    toggleShot,
    countChecked
  } = useShoot();
  const [preview, setPreview] = useState<ShotItem | null>(null);
  const allIds = shotSections.flatMap(section => section.items.map(item => item.id));
  // 9 Sep 2026, at Tom's request: a section with nothing added to it (no
  // B-Roll shots entered, say) is left out entirely rather than shown
  // empty — same "leave it out, don't grey it out" treatment already used
  // for the whole Shots tab when no shots exist at all (see App.tsx).
  const sectionsWithShots = shotSections.filter(section => section.items.length > 0);
  return <div className="pb-10" data-id="element-150" data-mp="38rdiaouohi9d">
      <ScreenHeader eyebrow="Shot List" title="Shots" meta="Tap a frame to view the reference full-screen." action={<span className="pt-1 text-right" data-id="element-152" data-mp="33qpra36g91f5">
            <span className="font-display text-2xl font-semibold tabular-nums tracking-display text-fg" data-id="element-153" data-mp="3igevy8dr3nk6">
              {countChecked(allIds, 'shot')}
            </span>
            <span className="font-display text-2xl font-semibold tabular-nums tracking-display text-dim" data-id="element-154" data-mp="2psj2rdne4ds5">
              /{allIds.length}
            </span>
          </span>} data-id="element-151" data-mp="38qlkr8hitagg" />

      {sectionsWithShots.map(section => {
      const ids = section.items.map(item => item.id);
      return <section key={section.id} aria-label={section.title} className="mt-8" data-id="element-155" data-mp="2urci7bm8meuy">
            <div className="flex items-baseline justify-between border-b border-line px-5 pb-3" data-id="element-156" data-mp="f0pvxjkbv6tc">
              <MetaLabel as="h2" tone="bright" data-id="element-157" data-mp="a1n26v9ssn0o">
                {section.title}
              </MetaLabel>
              <span className="text-[11px] tabular-nums text-dim" data-id="element-158" data-mp="h53dpghatqiy">
                {countChecked(ids, 'shot')} / {ids.length}
              </span>
            </div>

            <ul className="mt-3" data-id="element-159" data-mp="m23at1w67ixx">
              {section.items.map(item => {
            const checked = isShotChecked(item.id);
            return <li key={item.id} className="flex items-center gap-4 border-b border-line px-5 py-3" data-id="element-160" data-mp="w12ioi943ajv">
                    {item.image ? <button type="button" onClick={() => setPreview(item)} aria-label={`Open reference frame for ${item.title}`} className="shrink-0 focus:outline-none focus-visible:ring-1 focus-visible:ring-fg" data-id="element-161" data-mp="3uhmzropt6f76">
                        <img src={item.image} alt="" className={`h-16 w-24 object-cover transition-opacity duration-150 ease-out ${checked ? 'opacity-40' : 'opacity-100'}`} data-id="element-162" data-mp="3btrpwfxbhljc" />
                      </button> : <span className="flex h-16 w-24 shrink-0 items-center justify-center border border-line text-[9px] uppercase tracking-label text-dim" data-id="element-163" data-mp="1owa2fxnt7puo">
                        No ref
                      </span>}
                    <div className="min-w-0 flex-1" data-id="element-164" data-mp="1ez5r6svi5esn">
                      <p className={`font-display text-[18px] font-semibold leading-tight tracking-display ${checked ? 'text-muted line-through' : 'text-fg'}`} data-id="element-165" data-mp="1a7nq84thbe7o">
                        {item.title}
                      </p>
                      {item.camera ? <p className="mt-1.5 text-[10px] font-medium uppercase tracking-label text-dim" data-id="element-166" data-mp="w73695btvccl">
                          {item.camera}
                        </p> : null}
                    </div>
                    <CheckControl checked={checked} label={`Mark ${item.title} captured`} onToggle={() => toggleShot(item.id)} data-id="element-167" data-mp="2wa4de880dknx" />
                  </li>;
          })}
            </ul>
          </section>;
    })}

      <Lightbox open={Boolean(preview)} image={preview?.image} title={preview?.title} camera={preview?.camera} onClose={() => setPreview(null)} data-id="element-168" data-mp="28k0ay46k3qyi" />
    </div>;
}